import { render } from "./DirectorComponent.vue?vue&type=template&id=23961dd2&scoped=true"
import script from "./DirectorComponent.vue?vue&type=script&lang=js"
export * from "./DirectorComponent.vue?vue&type=script&lang=js"

import "./DirectorComponent.vue?vue&type=style&index=0&id=23961dd2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23961dd2"]])

export default __exports__